import { Button } from '@/components/Button';
import { GradientText } from '@/components/GradientText';
import { Text } from '@/components/Text';
import i18n from '@/translations/config';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useRouteError } from 'react-router-dom';

interface RouteError {
  statusText?: string;
  status?: number;
}

export const Error = () => {
  const error = useRouteError() as RouteError;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  // Récupérer l'état transmis lors de la navigation
  const state = location.state as RouteError | null;

  let message = t('common:error.occurred');
  const status = error?.status || state?.status || 500;
  const statusText = error?.statusText || state?.statusText || '';

  const handleRedirect = () => {
    navigate(`/${i18n.language}/dashboard`, { replace: true });
  };

  switch (status) {
    case 403: {
      message = statusText || t('common:error.unauthorized');
      break;
    }
    case 404: {
      message = statusText || t('common:error.not-found');
      break;
    }
    default: {
      message = statusText || t('common:error.occurred');
      break;
    }
  }

  return (
    <div className="flex size-full min-h-screen flex-col items-center justify-center bg-gradient-to-br from-sky-50 to-white p-4">
      <div className="flex w-full max-w-md flex-col items-center rounded-xl bg-white p-8 shadow-lg">
        <div className="mb-6 text-center">
          <GradientText className="text-4xl font-bold">{status}</GradientText>
          <Text className="mt-2 text-2xl font-semibold text-gray-800">
            {t('common:oops')} 🙁
          </Text>
        </div>

        <Text className="mb-6 text-center text-lg text-gray-600">
          {message}
        </Text>

        <Button
          className="w-full bg-gradient-to-r from-sky-600 to-sky-500 py-2.5 text-white shadow-md hover:from-sky-700 hover:to-sky-600 focus:ring-2 focus:ring-sky-300"
          onClick={handleRedirect}
        >
          {t('common:back-home')}
        </Button>

        <Text className="mt-4 text-center text-xs text-gray-400">
          Debug: {status} {statusText && `- ${statusText}`}
        </Text>
      </div>
    </div>
  );
};
